import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "showBorderTop", "showBorderBottom", "showBorderLeft", "showBorderRight"];
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { filterProps } from 'foundations-components/utils/filterProps';
import styled, { useTheme } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "PPUIGrid__StyledDiv",
  componentId: "lrw53s-0"
})(({
  $cssStyles
}) => {
  return Object.assign({
    display: 'grid'
  }, $cssStyles);
});
const gridStylePropKeys = {
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  display: true,
  gridRowStart: true,
  gridRowEnd: true,
  gridColumnStart: true,
  gridColumnEnd: true,
  justifyContent: true,
  justifyItems: true,
  alignContent: true,
  alignItems: true,
  placeContent: true,
  placeItems: true
};
function filterGridProps(props) {
  const gridProps = {};
  const rest = {};
  Object.keys(props).forEach(key => {
    if (key in gridStylePropKeys) {
      gridProps[key] = props[key];
    } else {
      rest[key] = props[key];
    }
  });

  // Trellis filterProps only supports tokenized props, which does NOT include grid style props
  const {
    domProps,
    tokenProps,
    callbackProps
  } = filterProps(rest);
  return {
    gridProps,
    domProps,
    tokenProps,
    callbackProps
  };
}
export const PPUIGrid = _ref => {
  let {
      children,
      showBorderTop,
      showBorderBottom,
      showBorderLeft,
      showBorderRight
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    gridProps,
    domProps,
    tokenProps,
    callbackProps
  } = filterGridProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const theme = useTheme();
  const border = `${theme.borderWidth[100]} solid ${theme.color['border-core-subtle']}`;
  return /*#__PURE__*/_jsx(StyledDiv, Object.assign({}, domProps, callbackProps, {
    $cssStyles: Object.assign({}, cssStyles, gridProps, {
      borderBlockStart: showBorderTop ? border : undefined,
      borderBlockEnd: showBorderBottom ? border : undefined,
      borderInlineStart: showBorderLeft ? border : undefined,
      borderInlineEnd: showBorderRight ? border : undefined
    }),
    children: children
  }));
};